import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { canUseDOM } from 'exenv';
import Ad from '../ad/ad';
import Body from './content/body';
import Sidebar from './content/sidebar';
import { isAdvertorial } from '../advertorial/advertorial';
import Autoplay from './utils/embed_autoplay';

export default class PostsContainer extends Component {
  constructor() {
    super();

    this.videosOnPage = [];
    this.cachedVideosOnPage = [];
    this.activatedVideosOnPage = [];
  }

  componentWillMount() {
    if (this.props.updateCorrelator && canUseDOM && window.googletag) {
      window.googletag.pubads().updateCorrelator();
    }
  }

  componentDidMount() {
    this.rendered = true;
  }

  shouldComponentUpdate() {
    const { props, rendered } = this;
    // initialPageLoad is needed for the first post to enable sticky ads.
    const isInitLoad = props.config.initialPageLoad;

    return !rendered || isInitLoad;
  }

  componentDidUpdate() {
    if (canUseDOM) {
      this.videosOnPage = document.querySelectorAll(
        '.inline-video iframe[src*="fastco"]'
      );
      if (this.cachedVideosOnPage.length !== this.videosOnPage.length) {
        this.cachedVideosOnPage = this.videosOnPage;
        for (let i = 0; i < this.activatedVideosOnPage.length; i += 1) {
          this.activatedVideosOnPage[i].off();
        }
        for (let i = 0; i < this.videosOnPage.length; i += 1) {
          const activeVid = new Autoplay(this.videosOnPage[i]);
          activeVid.on();
          this.activatedVideosOnPage.push(activeVid);
        }
      }
    }
  }

  componentWillUnmount() {
    for (let i = 0; i < this.activatedVideosOnPage.length; i += 1) {
      this.activatedVideosOnPage[i].off();
    }
  }

  setWrapperClasses(advertorial) {
    const classNames = ['post__wrapper'];

    if (advertorial) {
      classNames.push('post__wrapper--advertorial');
    }

    return classNames.join(' ');
  }

  renderPostBody(post, index, advertorial, related) {
    const {
      posts,
      config,
      isDesktop,
      isFirstPost,
      videoAdData,
      combinedAdModel,
      pageNum,
      live
    } = this.props;
    const totalPosts = posts.length;
    let hasNewsletter = true;
    const isLongPost = post.layout === 'long';
    let isVideoPost = false;

    if (totalPosts > 1) {
      hasNewsletter = isFirstPost && index === totalPosts - 1;
    }

    if (config.featureFlags.videoPagesEnabled) {
      isVideoPost = post.layout === 'video';
      if (isVideoPost) {
        hasNewsletter = false;
      }
    }

    return (
      <Body
        key={post.id}
        post={post}
        advertorial={advertorial}
        combinedAdModel={combinedAdModel}
        isFirstPost={isFirstPost}
        config={config}
        isDesktop={isDesktop}
        videoAdData={videoAdData}
        pageNum={pageNum}
        isLongPost={isLongPost}
        isVideoPost={isVideoPost}
        hasNewsletter={hasNewsletter}
        related={related}
        live={live}
      />
    );
  }

  render() {
    const {
      config,
      posts,
      related,
      isDesktop,
      isFirstPost,
      combinedAdModel,
      pageNum
    } = this.props;
    const firstPost = get(posts, '[0]');
    const tags = get(firstPost, 'tags');
    const advertorial = isAdvertorial(tags);

    const adName = isFirstPost ? 'flexiblepushdown' : 'flexiblebillboard';
    const isLongPost = firstPost.layout === 'long';

    let isVideoPost = false;
    if (!firstPost) return null;

    if (config.featureFlags.videoPagesEnabled) {
      isVideoPost = get(firstPost, 'layout', false) === 'video';
    }

    return (
      <div className={this.setWrapperClasses(advertorial)}>
        <div className="post__article-top-ad-wrapper">
          <Ad
            {...combinedAdModel}
            name={adName}
            region="articletop"
            pageNum={pageNum}
          />
          <Ad
            {...combinedAdModel}
            name="mobileleaderboard"
            region="articletop"
            pageNum={pageNum}
          />
          <Ad
            {...combinedAdModel}
            name="oop"
            slug={false}
            oop={true}
            pageNum={pageNum}
          />
        </div>
        <div className={`post ${isVideoPost ? 'post--video' : ''}`}>
          <div className="post__main">
            {posts.map((post, index) =>
              this.renderPostBody(post, index, advertorial, related)
            )}
          </div>
          <Sidebar
            config={config}
            post={firstPost}
            related={related}
            isFirstPost={isFirstPost}
            combinedAdModel={combinedAdModel}
            isDesktop={isDesktop}
            pageNum={pageNum}
            fullPageAdvertorial={advertorial}
            isLongPost={isLongPost}
            isVideoPost={isVideoPost}
          />
        </div>
      </div>
    );
  }
}

PostsContainer.defaultProps = {
  isDesktop: false,
  isFirstPost: false,
  related: [],
  updateCorrelator: false,
  live: false
};

PostsContainer.propTypes = {
  config: PropTypes.shape({}).isRequired,
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  combinedAdModel: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  isFirstPost: PropTypes.bool,
  videoAdData: PropTypes.shape({}).isRequired,
  pageNum: PropTypes.number.isRequired,
  updateCorrelator: PropTypes.bool,
  live: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/components/post/container.js